export default function removeUndefinedFromList<T>(list: (T | undefined)[]): T[] {
    return list.flatMap(item => item ? [item] : []);
}